const test = (re) => (c) => re.test(c.name);
const isName = test(/(company|customer|contact|full)?_?name$|^name|company/i);
const isAddress = test(/address|street|city|town|region|state|province|postal|zip|country/i);
const isPhone = test(/phone|fax|mobile|cell|tel/i);
const isEmail = test(/e-?mail/i);

export function contactFields(columns) {
  const text = columns.filter((c) => c.type === "text");
  const names = text.filter(isName);
  return {
    title: names[0] || text[0] || columns[0],
    subtitle: names[1] || text.find(test(/title|role|position/i)),
    address: text.filter(isAddress),
    phones: text.filter(isPhone),
    emails: text.filter(isEmail),
  };
}

export const looksLikeContacts = (columns) => {
  const f = contactFields(columns);
  const own = f.address.filter((c) => !/^ship/i.test(c.name));
  return f.phones.length + f.emails.length >= 1 && own.length >= 1;
};

export const formatDate = (v) => {
  const m = String(v ?? "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return v;
  return new Date(+m[1], +m[2] - 1, +m[3]).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
};

export const testKey = (s) => String(s).replace(/\s+/g, "-");
